import { enqueueNotification, SnackbarItem } from '@core/features/snackbar';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { heroApiService } from '@services/.';
import { ExtraReducer, getSideEffectState } from '@utils/.';
import { AuthReducerProps } from '../type';

export const fetchAccountFacebook = createAsyncThunk(
  'business/fetchAccountFacebook',
  async (_, thunkApi) => {
    try {
      const socialAccount = await heroApiService.getFacebookProfile();
      return socialAccount;
    } catch (error: any) {
      thunkApi.dispatch(
        enqueueNotification({
          name: 'Failed to fetch account Facebook',
          description: 'There was error fetching Facebook. Please refresh the page',
          type: 'Error',
        } as SnackbarItem)
      );
      return undefined;
    }
  }
);

const [fulfilled, pending, rejected] = getSideEffectState(fetchAccountFacebook);

export const fetchAccountFacebookReducer = {
  [fulfilled]: (state, action) => {
    state.isLoading = false;
    state.integration.facebook = action.payload;
  },
  [rejected]: (state, action) => {
    state.isLoading = false;
    state.integration.facebook = undefined;
  },
  [pending]: (state, action) => {
    state.isLoading = true;
  },
} as ExtraReducer<AuthReducerProps>;
